import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import React from 'react';
import SimpleHeader from '../../../main/headers/simpleHeader';

const BrandLayout = ({ title, brandId, children }) => (
  <div>
    <SimpleHeader heading={title} />
    <div className="u-max-width-710 u-margin-auto u-ph- large-and-up-ph0">
      <ul className="c-nav-tabs list-bare u-mt- medium-and-up-mt">
        <li>
          <Link to={`/admin/brands/${brandId}`} activeClassName="is-active" className="c-nav-tab">
            Main <br /> Settings
          </Link>
        </li>
        <li>
          <Link to={`/admin/brands/${brandId}/subscription`} activeClassName="is-active" className="c-nav-tab">
            Subscription
          </Link>
        </li>
        <li>
          <Link to={`/admin/brands/${brandId}/import`} activeClassName="is-active" className="c-nav-tab">
            Import
          </Link>
        </li>
      </ul>
    </div>
    <div className="u--mt-- large-and-up--mt">{children}</div>
  </div>
);

BrandLayout.propTypes = {
  title: PropTypes.string,
  brandId: PropTypes.string.isRequired,
  children: PropTypes.node,
};

BrandLayout.defaultProps = {
  title: '',
  children: null,
};

export default BrandLayout;
